"use strict";

import Swiper from '/../../main/node_modules/swiper';
// Add below if you need any modules
import {Navigation} from '/../../main/node_modules/swiper/modules';

var agent_slider_array = [];

const helpers = {
    setUrlParameter: (key, value) => {
        let url = new URL(window.location.href);
        let query_string = url.search;
        let search_params = new URLSearchParams(query_string);

        search_params.set(key, value);
        // Dont encode so the filter cats stay with commas
        url.search = decodeURIComponent(search_params.toString());

        window.history.pushState({}, "", url);
    },
    deleteUrlParameter: (key) => {
        let url = new URL(window.location.href);
        let query_string = url.search;
        let search_params = new URLSearchParams(query_string);

        search_params.delete(key);
        url.search = search_params.toString();

        window.history.pushState({}, "", url);
    },
    getUrlParameter: (name, url) => {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },
    setCookie: (name, value, time = '') => {
        var expires = (time ? '; expires=' + time : '');
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    },
    getCookie: (name,) => {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    },
    isTouchDevice: () => {
        return (('ontouchstart' in window) ||
            (navigator.maxTouchPoints > 0) ||
            (navigator.msMaxTouchPoints > 0));
    },
    isMobile: () => {
        return (window.innerWidth <= 1024);
    },
    isMobileMenu: () => {
        return (window.innerWidth <= 1199);
    },
    debounce: (func, time = 100) => {
        var timer;
        return function(event){
            if(timer){
                clearTimeout(timer);
            }
            timer = setTimeout(func, time, event);
        };
    },
    agentSliderInit: (slider, index) => {
        let mobile_bp = window.matchMedia('(min-width: 0px) and (max-width: 1023px)');
        let desktop_bp = window.matchMedia('(min-width: 1024px)');
        var is_initialised = $(slider).hasClass('swiper-initialized');

        var $next_button = $(slider).parents('.js-map-list-container').find('.js-slider-next');
        var $prev_button = $(slider).parents('.js-map-list-container').find('.js-slider-prev');

        if(mobile_bp.matches) {
            if(!is_initialised) {
                $next_button.removeClass('swiper-button-lock');
                $prev_button.removeClass('swiper-button-lock');

                var settings = {
                    modules: [Navigation],
                    loop: true,
                    watchOverflow: true,
                    slidesPerView: 1,
                    navigation: {
                        nextEl: $next_button[0],
                        prevEl: $prev_button[0],
                    },
                    breakpoints: {
                        767: {
                            slidesPerView: 2,
                        },
                    }
                };

                var $array_slider = new Swiper(slider, settings);
                agent_slider_array[index] = $array_slider;
                is_initialised = true;
            }

            var $array_slider = agent_slider_array[index];
            $array_slider.update();
        } else {
            $next_button.addClass('swiper-button-lock');
            $prev_button.addClass('swiper-button-lock');

            if (is_initialised) {
                var $array_slider = agent_slider_array[index];
                $array_slider.destroy();
            }
        }
    }
};

export default helpers;